import { memo, useEffect } from "react";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import FooterSection from "./Footer";
import { useLocation } from "react-router-dom";
import { useIsAtPageBottom } from "src/hooks/useIsAtPageBottom";

const MainLayout = memo(function MainLayout() {
  const location = useLocation();
  const isAtBottom = useIsAtPageBottom({ thresholdPx: 32 });

  // Recompute after route changes (some pages load content async).
  useEffect(() => {
    requestAnimationFrame(() => {
      window.dispatchEvent(new Event("scroll"));
    });
  }, [location.pathname]);

  return (
    <div className="min-h-screen flex flex-col max-h-full">
      <Header />
      <main className="flex-1 pb-5">
        <Outlet />
      </main>
      <FooterSection visible={isAtBottom} />
    </div>
  );
});

export default MainLayout;
